var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"accent","depressed":"","href":"https://manage.kmail-lists.com/subscriptions/subscribe?a=UbCwF6&g=W6DyQ2","target":"_blank"}},[_vm._t("default",function(){return [_vm._v("\n      Receive Updates\n    ")]}),_c('v-icon',{attrs:{"right":""}},[_vm._v("open_in_new")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }